import React, { createContext, useContext, useState } from "react";

const articleContext = createContext();

export const useArticle = () => useContext(articleContext);

export const ArticleProvider = ({ children }) => {
  const [articles, setArticles] = useState([]);

  return (
    <articleContext.Provider value={[articles, setArticles]}>
      {children}
    </articleContext.Provider>
  );
};
